export default __webpack_public_path__ + "assets/webgl/scene-27.b7118734.glb";